import React, { useEffect, useRef } from "react";
import "./intro.scss";
import { init } from "ityped";

export default function Intro() {
  const textRef = useRef();
  useEffect(() => {
    init(textRef.current, {
      backDelay: 1500,
      backSpeed: 60,
      showCursor: true,
      strings: ["FullStack", "WebAPI", "React.js", "node.js", "React Native"],
    });
  }, []);
  return (
    <>
      <div className="intro" id="intro">
        <div className="left">
          <div className="imgContainer">
            <img src="assets/man.png" alt="" srcset="" />
          </div>
        </div>
        <div className="right">
          <div className="wrapper">
            <h2>Hi There,I'm</h2>
            <h1>Randima Silva</h1>
            <h3>
              Freelance <span ref={textRef}>Designer</span>
            </h3>
          </div>
          <a href="#work">
            <img src="assets/down.png" alt="" />
          </a>
        </div>
      </div>
    </>
  );
}
